export const messages = {
    "wre-dashboard.nav-menu.item.shared": "共享",
    "wre-dashboard.nav-menu.item.backups": "备份",
    "wre-dashboard.nav-menu.item.machines": "计算机",
    "wre-dashboard.nav-menu.item.account": "帐户",
    "wre-dashboard.search.input.hint": "搜索",
    "wre-dashboard.search.label.breadcrumb": "搜索结果",
    "wre-dashboard.search.message.empty": "没有搜索到匹配的项目",
    "wre-dashboard.side-bar.selected.title:plural": "{count} 个项目已选定 | {count} 个项目已选定",
    "wre-dashboard.side-bar.backup-type.disk": "磁盘",
    "wre-dashboard.side-bar.backup-type.file": "文件",
    "wre-dashboard.side-bar.backup-type.notarized": "公证的文件和文件夹",
    "wre-dashboard.side-bar.backup-type.exchange": "应用程序 - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "应用程序 - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "应用程序 - 系统状态",
    "wre-dashboard.side-bar.backup-type.application": "应用程序",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} 剩余量",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} 已用量",
    "wre-dashboard.space-indicator.label.unlimited": "无限制",
    "wre-dashboard.backups-table.column.name": "名称",
    "wre-dashboard.backups-table.column.size": "大小",
    "wre-dashboard.backups-table.column.version": "上次备份",
    "wre-dashboard.backups-table.message.no-backups": "云中尚未有备份",
    "wre-dashboard.backups-sidebar.label.size": "大小",
    "wre-dashboard.backups-sidebar.label.type": "类型",
    "wre-dashboard.backups-sidebar.label.version": "上一个版本",
    "wre-dashboard.backups-sidebar.label.created": "创建时间",
    "wre-dashboard.backups-sidebar.label.machine": "计算机",
    "wre-dashboard.backups-sidebar.label.owner": "所有者",
    "wre-dashboard.content-table.column.name": "名称",
    "wre-dashboard.content-table.column.versions": "版本",
    "wre-dashboard.content-table.column.volumes": "卷标",
    "wre-dashboard.content-table.column.path": "路径",
    "wre-dashboard.content-table.column.size": "大小",
    "wre-dashboard.content-table.column.version": "上一个版本",
    "wre-dashboard.content-table.action.versions": "版本",
    "wre-dashboard.content-table.action.restore": "下载",
    "wre-dashboard.content-table.action.share": "共享链接",
    "wre-dashboard.content-table.label.size": "大小",
    "wre-dashboard.content-table.label.created": "创建时间",
    "wre-dashboard.content-table.label.modified": "修改时间",
    "wre-dashboard.content-table.message.empty-folder": "此文件夹为空",
    "wre-dashboard.password-dialog-box.title.backup": "加密备份",
    "wre-dashboard.password-dialog-box.title.archive": "加密存档",
    "wre-dashboard.password-dialog-box.message.backup": "请指定备份 {displayName} 的访问密码",
    "wre-dashboard.password-dialog-box.message.archive": "请指定存档 {displayName} 的访问密码",
    "wre-dashboard.password-dialog-box.hint.password": "密码",
    "wre-dashboard.password-dialog-box.message.invalid-password": "密码不正确",
    "wre-dashboard.form.button.open": "打开",
    "wre-dashboard.form.button.close": "关闭",
    "wre-dashboard.form.button.cancel": "取消",
    "wre-dashboard.form.button.delete": "删除",
    "wre-dashboard.shared-content-table.column.name": "名称",
    "wre-dashboard.shared-content-table.column.location": "位置",
    "wre-dashboard.shared-content-table.column.source": "来源",
    "wre-dashboard.shared-content-table.column.days": "天",
    "wre-dashboard.shared-content-table.column.downloads": "下载",
    "wre-dashboard.shared-content-table.column.shared": "共享于",
    "wre-dashboard.shared-content-table.label.shared": "共享于",
    "wre-dashboard.shared-content-table.label.backup": "来源",
    "wre-dashboard.shared-content-table.action.share": "共享链接",
    "wre-dashboard.shared-content-table.action.settings": "链接设置",
    "wre-dashboard.shared-content-table.action.delete": "删除链接",
    "wre-dashboard.shared-content-table.action.delete-selected": "删除链接",
    "wre-dashboard.account-page.message.used-space": "{brandName}：{spaceFree} 已释放，共 {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}：无限空间",
    "wre-dashboard.account-page.button.sign-out": "注销",
    "wre-dashboard.account-page.button.manage-subscription": "管理许可证",
    "wre-dashboard.account-page.message.subscription.active": "您的 {brandName} 空间的许可证到期日期如下",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} 试用有效期",
    "wre-dashboard.account-page.message.subscription.expired": "您的 {brandName} 空间的许可证到期日期如下",
    "wre-dashboard.account-page.message.worm-status.storage-full": "您的 {brandName} 存储空间已满。您无法将数据备份或存档至云。",
    "wre-dashboard.account-page.message.worm-status.less-than": "可用空间少于 {percent}%。您即将无法使用 {brandName}。",
    "wre-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "复制链接",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "链接设置",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "获得此链接的任何人都可查看上一个版本的数据",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "共享于 {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "链接已复制",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "链接复制错误",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "删除链接",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "对于任何获得此链接的人而言，它将不再可用",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "删除链接",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "对于任何获得这些链接的人而言，它们将不再可用",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "链接设置",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "删除链接",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "完成",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "密码",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "重置密码",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "密码保护",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "使用密码保护此链接",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "到期",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "下载限制",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "在 {splitMarker} 天后禁用此链接 | 在 {splitMarker} 天后禁用此链接",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "下载 {splitMarker} 次后禁用此链接 | 下载 {splitMarker} 次后禁用此链接",
    "wre-dashboard.sub-accounts-dialog-box.title": "帐户",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "搜索",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "没有搜索到匹配的项目",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "名称",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "使用情况",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "上次备份",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "到期",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} 可用空间 {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "批量订阅",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "已过期",
    "wre-dashboard.machines-table.column.name": "名称",
    "wre-dashboard.machines-table.column.size": "大小",
    "wre-dashboard.machines-table.message.no-machines": "在云中还没有计算机"
};
